(() => {
  function setup(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const compose = root.querySelector('[data-review-compose]');
    if (root.querySelector('[data-review-errors], .pr-feedback')) compose.open = true;
    const filter = root.querySelector('[data-photos-only]');
    filter?.addEventListener('change', () => {
      let visible = 0;
      root.querySelectorAll('[data-review-card]').forEach(card => {
        card.hidden = filter.checked && card.dataset.hasPhoto !== 'true';
        if (!card.hidden) visible++;
      });
      root.querySelector('[data-filter-empty]').hidden = visible > 0;
    });
    const dialog = root.querySelector('dialog');
    let opener;
    root.querySelectorAll('[data-review-photo]').forEach(link => {
      link.addEventListener('click', event => {
        if (!dialog?.showModal) return;
        event.preventDefault();
        opener = link;
        const picture = new Image();
        picture.src = link.href;
        picture.alt = link.querySelector('img').alt;
        root.querySelector('[data-photo-container]').replaceChildren(picture);
        dialog.showModal();
      });
    });
    root.querySelector('[data-close-photo]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', event => {
      if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }
    });
    dialog?.addEventListener('close', () => opener?.focus());
  }
  const initialize = () => document.querySelectorAll('[data-photo-reviews]').forEach(setup);
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
